<template>
  <footer>
    <div class="footer">
      <ul>
        <li>
          <b>{{ $t('ui.footer.follow_us') }}</b>
        </li>
        <li>
          <!--          <font-awesome-icon class="social-icon" :icon="['fab', 'meetup']"/>&nbsp;-->
          <a href="https://www.meetup.com/de-DE/Berlin-Shogi-Gruppe/">
            Meetup
          </a>
        </li>
        <li>
          <!--          <font-awesome-icon class="social-icon" :icon="['fab', 'telegram-plane']"/>&nbsp;-->
          <a href="http://www.telegram.me/ShogiBerlin">
            Telegram
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <b>{{ $t('ui.footer.visit_us') }}</b>
        </li>
        <li>
          <address>
            <a href="https://www.google.com/maps/place/Ziegelstraße+5,+10117+Berlin/">
              <!--              <font-awesome-icon class="social-icon" icon="map-marked"/>-->
              Ziegelstraße 5
              <br />
              10117 Berlin
            </a>
          </address>
        </li>
      </ul>
      <ul>
        <li>
          <b>{{ $t('ui.footer.misc') }}</b>
        </li>
        <li>
          <router-link :to="getLocalUrl('/anhang')" v-scroll-to="'#nav-col'">
            {{ $t('ui.footer.appendix') }}
          </router-link>
        </li>
        <li>
          <router-link :to="getLocalUrl('/privacy_statement')" v-scroll-to="'#nav-col'">
            {{ $t('ui.footer.privacy') }}
          </router-link>
        </li>
        <li>
          <router-link :to="getLocalUrl('/legal_notice')" v-scroll-to="'#nav-col'">
            {{ $t('ui.footer.legal_notice') }}
          </router-link>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    getLocalUrl(url) {
      const { locale } = this.$i18n;
      const localeStr = locale !== 'de' ? `/${locale}` : '';
      return `${localeStr}${url}`;
    },
  },
};
</script>

<style scoped>
footer {
  z-index: 3;
  background: #ffffffcc;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

footer > .footer {
  padding: 0 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-start;
}

.footer > ul {
  margin: 15px;
  padding: 0;
  width: 90px;
}

.footer > ul > li:first-child {
  margin-bottom: 5px;
}

.footer > ul > li {
  font-size: 14px;
  list-style: none;
  text-align: center;
}

a {
  display: inline-block;
  padding: 3px 0;
  margin: 2px 0;
}

a:hover {
  text-decoration-color: var(--link-color);
}

address {
  display: inline-block;
}

.social-icon {
  display: inline-flex;
  /*color: white;*/
  color: var(--link-color);
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
}
</style>
